'use strict';

var regexCheck = require('../util/regex-check.js');
var asciiAlpha = regexCheck(/[A-Za-z]/);
module.exports = asciiAlpha;